import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#FFA500', // A
          'primary-darken1': '#cc8c25', // R
          'primary-lighten1': '#FFF4DF', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#009CA6', // B
          'secondary-darken1': '#00005C', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#FFA500', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#FFA500', // H
          topSecondaryBtn: '#009CA6', // I
          topSecondaryBtnText: '#FFFFFF', // J
          topPrimaryBtn: '#FFA500', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#FFA500', // N
          secondaryOutLineBtnText: '#FFA500', // O
          topBtnUpTextSp: '#009CA6', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#D4A500',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#FFA500',
          accent: '#FFA500', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
